module.exports = __webpack_public_path__ + "site/img/16.f4a7e63d.jpg";